module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/big/58-ea800b1eb7d0d6f30e49cc0be22366bc.webp";